import React from 'react'
import { Backdrop, CircularProgress } from '@material-ui/core'

const LoadingBackdrop = ({ open }) => (
    <Backdrop open={open ?? false} unmountOnExit style={{ zIndex: 10000 }}>
        <CircularProgress />
    </Backdrop>
)

export default LoadingBackdrop